import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap-5';

import OverrideButton from './override_button';

export default function OptionLayout({ children, isOverridden, label, onRemove, onReset }) {
  return (
    <Row className="align-items-center">
      <Col md={6} xs={8}>
        <Row className="g-0">
          <Col className="px-2 py-1 bg-light border border-end-0" xs={3}>
            <span className="form-label mb-0">{label}</span>
          </Col>
          <Col className={`px-4 py-1 border${!isOverridden ? ' d-flex align-items-center' : ''}`} xs={9}>
            {isOverridden ? children : <span className="text-muted">Buildout Default</span>}
          </Col>
        </Row>
      </Col>
      <Col md={6} xs={4}>
        <OverrideButton
          disabled={!isOverridden}
          onRemove={onRemove}
          onReset={onReset}
        />
      </Col>
    </Row>
  );
}

OptionLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isOverridden: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};
